import React from 'react';

const DocumentSelector = () => {
  return (
    <div className="bg-white p-4 rounded-lg shadow-md mb-6">
      <h3 className="text-lg font-semibold text-gray-800 mb-4">文件選擇</h3>
      <p className="text-gray-600">請選擇要查看的文件...</p>
    </div>
  );
};

export default DocumentSelector; 